{
  "organizationLabel": "組織:",
  "profileDropdownAccountInfoItem": "帳戶資訊 (內部)",
  "profileDropdownAccountSettingsHeader": "帳戶設定",
  "profileDropdownProductSettingsHeader": "產品設定",
  "profileDropdownUserSettingsItem": "偏好設定",
  "profileLegalNoticesMenuItem": "法律注意事項",
  "signOut": "登出",
  "themeInfoTooltip": "並非所有應用程式都支援深色主題。",
  "userProfileName": "{lastName} {firstName}",
  "userThemeSwitchLabel": "深色主題"
}
